module.exports = __webpack_public_path__ + "img/icon-shenpi.f9f8061e.png";